// export default IncidentRequest;
import BackButton from "components/BackButton";
import React, { useState } from "react";
import ChangeOfVenueDetail from "./ChangeOfVenueDetail";
import ChangeOfVenueList from "./ChangeOfVenueList";

type Props = {
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const ChangeOfVenueTab: React.FC<Props> = ({
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const [pageType, setPageType] = useState<"list" | "detail">("list");
  const [selectedId, setSelectedId] = useState<string | number>("");

  return (
    <div>
      {pageType === "list" ? (
        <ChangeOfVenueList
          crimeReferenceNumber={crimeReferenceNumber}
          incidentRegistrationNumber={incidentRegistrationNumber}
          setSelectedId={setSelectedId}
          setPageType={setPageType}
        />
      ) : (
        <div>
          <BackButton onClick={() => setPageType("list")} />
          <ChangeOfVenueDetail selectedId={selectedId} />
        </div>
      )}
    </div>
  );
};

export default ChangeOfVenueTab;
